module.exports = __webpack_public_path__ + "static/header-854d3f27238f78e2aaeaea5f430ed879.jpg";